import { render, staticRenderFns } from "./BoxField.vue?vue&type=template&id=6f6aecb8&scoped=true&"
import script from "./BoxField.vue?vue&type=script&lang=js&"
export * from "./BoxField.vue?vue&type=script&lang=js&"
import style0 from "./BoxField.vue?vue&type=style&index=0&id=6f6aecb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6aecb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
